const OOSIcon = ({ width = '65', height = '66', className = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 65 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M54.4648 17.4788H22.0364C20.9804 17.4788 20.3789 18.3101 20.6915 19.3382L25.8221 34.6553C26.0749 35.4803 26.969 36.1504 27.8183 36.1504H49.0802C49.9295 36.1504 50.8236 35.4815 51.0727 34.6553L55.5432 18.9765C55.7998 18.1489 55.3166 17.4788 54.4648 17.4788Z"
        fill="#E2E5E7"
      />
      <path
        d="M24.9691 58.7414C27.6485 58.7414 29.8207 56.5275 29.8207 53.7965C29.8207 51.0655 27.6485 48.8516 24.9691 48.8516C22.2896 48.8516 20.1174 51.0655 20.1174 53.7965C20.1174 56.5275 22.2896 58.7414 24.9691 58.7414Z"
        fill="#E2E5E7"
      />
      <path
        d="M45.4964 58.8022C48.1759 58.8022 50.348 56.5883 50.348 53.8573C50.348 51.1263 48.1759 48.9124 45.4964 48.9124C42.8169 48.9124 40.6448 51.1263 40.6448 53.8573C40.6448 56.5883 42.8169 58.8022 45.4964 58.8022Z"
        fill="#E2E5E7"
      />
      <path
        d="M51.3206 41.1828H22.9506L11.5911 7.87061H2.74709C2.01852 7.87061 1.31979 8.1656 0.804605 8.69068C0.289425 9.21577 0 9.92794 0 10.6705C0 11.4131 0.289425 12.1253 0.804605 12.6504C1.31979 13.1755 2.01852 13.4705 2.74709 13.4705H7.6834L19.0416 46.7814H51.3206C52.0492 46.7814 52.7479 46.4864 53.2631 45.9613C53.7783 45.4362 54.0677 44.7241 54.0677 43.9815C54.0677 43.2389 53.7783 42.5267 53.2631 42.0016C52.7479 41.4766 52.0492 41.1828 51.3206 41.1828Z"
        fill="#E2E5E7"
      />
      <path
        d="M58.9966 0L60.9953 2.03585L2.56289 61.592L0.564209 59.5561L58.9966 0ZM62.9927 4.07296L64.9902 6.10881L6.559 65.6649L4.56032 63.6265L62.9927 4.07296Z"
        fill="white"
      />
      <path
        d="M60.9939 2.03589L62.9926 4.073L4.56018 63.6291L2.56274 61.592L60.9939 2.03589Z"
        fill="#C4514D"
      />
    </svg>
  )
}

export default OOSIcon
